import { Text } from '@chakra-ui/react';

import { useTranslations } from '../../../../contexts/LocalizationContext';
import { ScanStateLayout } from '../components/ScanStateLayout';
import { getIconPath } from '../utils/state.helper';

type ErrorStateProps = {
  onAnimationComplete: () => void;
  progressResetKey?: string | number;
};

export const ErrorState = ({ onAnimationComplete, progressResetKey }: ErrorStateProps) => {
  const translations = useTranslations();

  return (
    <ScanStateLayout
      heading={translations('scan_modal_error_heading')}
      imageSrc={getIconPath('error.svg')}
      onAnimationComplete={onAnimationComplete}
      progressResetKey={progressResetKey}
    >
      <Text fontSize={18}>{translations('scan_modal_error_footer')}</Text>
    </ScanStateLayout>
  );
};
